import { render } from "./ListeDepotPage.vue?vue&type=template&id=510e36ad&ts=true"
import script from "./ListeDepotPage.vue?vue&type=script&lang=ts"
export * from "./ListeDepotPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__